import { setMainCategoryFilerBasedOnUrlValue } from './category.actions';
import { TypedAction } from '@ngrx/store/src/models';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class CategoryFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    return setMainCategoryFilerBasedOnUrlValue({
      value: urlValue,
    });
  }

  serialize(state: AppState): string {
    return state.filter.category.main.filter.value;
  }
}
